function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ApiConstants, ThunkHelper } from 'invision-core';
export var PAGE_SIZE = 5;
export var FETCH_CUSTOMER_INVENTORY = {
  BEGIN: 'FETCH_CUSTOMER_INVENTORY.BEGIN',
  FAILURE: 'FETCH_CUSTOMER_INVENTORY.FAILURE',
  SUCCESS: 'FETCH_CUSTOMER_INVENTORY.SUCCESS'
};
var FETCH_CUSTOMER_INVENTORY_TYPES = [FETCH_CUSTOMER_INVENTORY.BEGIN, FETCH_CUSTOMER_INVENTORY.SUCCESS, FETCH_CUSTOMER_INVENTORY.FAILURE];
export var RETRIEVE_CUSTOMER_INVENTORY_ITEM = {
  BEGIN: 'RETRIEVE_CUSTOMER_INVENTORY_ITEM.BEGIN',
  FAILURE: 'RETRIEVE_CUSTOMER_INVENTORY_ITEM.FAILURE',
  SUCCESS: 'RETRIEVE_CUSTOMER_INVENTORY_ITEM.SUCCESS'
};
export var RETRIEVE_CUSTOMER_INVENTORY_ITEM_ACTIVITIES = {
  BEGIN: 'RETRIEVE_CUSTOMER_INVENTORY_ITEM_ACTIVITIES.BEGIN',
  FAILURE: 'RETRIEVE_CUSTOMER_INVENTORY_ITEM_ACTIVITIES.FAILURE',
  SUCCESS: 'RETRIEVE_CUSTOMER_INVENTORY_ITEM_ACTIVITIES.SUCCESS'
};
var RETRIEVE_CUSTOMER_INVENTORY_ITEM_TYPES = [RETRIEVE_CUSTOMER_INVENTORY_ITEM.BEGIN, RETRIEVE_CUSTOMER_INVENTORY_ITEM.SUCCESS, RETRIEVE_CUSTOMER_INVENTORY_ITEM.FAILURE];
var RETRIEVE_CUSTOMER_INVENTORY_ITEM_ACTIVITIES_TYPES = [RETRIEVE_CUSTOMER_INVENTORY_ITEM_ACTIVITIES.BEGIN, RETRIEVE_CUSTOMER_INVENTORY_ITEM_ACTIVITIES.SUCCESS, RETRIEVE_CUSTOMER_INVENTORY_ITEM_ACTIVITIES.FAILURE];
export var UPDATE_INVENTORY_FRIENDLY_NAME = {
  BEGIN: 'UPDATE_INVENTORY_FRIENDLY_NAME.BEGIN',
  SUCCESS: 'UPDATE_INVENTORY_FRIENDLY_NAME.SUCCESS',
  FAILURE: 'UPDATE_INVENTORY_FRIENDLY_NAME.FAILURE'
};
var UPDATE_INVENTORY_FRIENDLY_NAME_CONSTANTS = [UPDATE_INVENTORY_FRIENDLY_NAME.BEGIN, UPDATE_INVENTORY_FRIENDLY_NAME.SUCCESS, UPDATE_INVENTORY_FRIENDLY_NAME.FAILURE];
export var fetchCustomerInventoryPromise = function fetchCustomerInventoryPromise(dispatch, customerId) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return ThunkHelper(dispatch, FETCH_CUSTOMER_INVENTORY_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/SearchSubscriberInventory',
    data: {
      InternalStatus: params.internalStatus,
      InventoryCategory: params.inventoryCategory,
      InventoryId: params.inventoryId,
      InventoryTypeName: params.inventoryTypeName,
      PageNumber: params.pageNumber,
      PageSize: params.pageSize,
      SerialNumber: params.serialNumber,
      ServiceIdentifierValue: params.serviceIdentifierValue
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var fetchCustomerInventory = function fetchCustomerInventory(customerId, params) {
  return function (dispatch) {
    return fetchCustomerInventoryPromise(dispatch, customerId, params);
  };
};
export var retrieveCustomerInventoryItemPromise = function retrieveCustomerInventoryItemPromise(dispatch, customerId, instanceId, inventoryId) {
  return ThunkHelper(dispatch, RETRIEVE_CUSTOMER_INVENTORY_ITEM_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveSubscriberInventory',
    data: {
      InstanceId: instanceId
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  }, {
    inventoryId: inventoryId
  });
};
export var retrieveCustomerInventoryItemActivitiesPromise = function retrieveCustomerInventoryItemActivitiesPromise(dispatch, customerId, subscriberProductId) {
  return ThunkHelper(dispatch, RETRIEVE_CUSTOMER_INVENTORY_ITEM_ACTIVITIES_TYPES, {
    data: {
      PageSize: PAGE_SIZE,
      SubscriberProductId: subscriberProductId
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    method: 'post',
    url: 'SubscriberManagement/RetrieveSubscriberFinanceActivityDetails'
  });
};
export var retrieveCustomerInventoryItemActivities = function retrieveCustomerInventoryItemActivities(customerId, subscriberProductId) {
  return function (dispatch) {
    return retrieveCustomerInventoryItemActivitiesPromise(dispatch, customerId, subscriberProductId);
  };
};
export var RETRIEVE_CUSTOMER_INVENTORY_ITEM_FINANCE = {
  BEGIN: 'RETRIEVE_CUSTOMER_INVENTORY_ITEM_FINANCE.BEGIN',
  SUCCESS: 'RETRIEVE_CUSTOMER_INVENTORY_ITEM_FINANCE.SUCCESS',
  FAILURE: 'RETRIEVE_CUSTOMER_INVENTORY_ITEM_FINANCE.FAILURE'
};
export var fetchInventoryItemFinanceDetails = function fetchInventoryItemFinanceDetails(customerId, serviceIdentifiers) {
  return function (dispatch) {
    return fetchInventoryItemFinanceDetailsPromise(dispatch, customerId, serviceIdentifiers);
  };
};
export var fetchInventoryItemFinanceDetailsPromise = function fetchInventoryItemFinanceDetailsPromise(dispatch, customerId, serviceIdentifiers) {
  return ThunkHelper(dispatch, Object.values(RETRIEVE_CUSTOMER_INVENTORY_ITEM_FINANCE), {
    method: 'post',
    url: 'SubscriberManagement/RetrieveSubscriberFinanceDetails',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {
      ServiceIdentifiers: serviceIdentifiers
    }
  });
};
export var retrieveCustomerInventoryItem = function retrieveCustomerInventoryItem(customerId, instanceId, inventoryId) {
  return function (dispatch) {
    return retrieveCustomerInventoryItemPromise(dispatch, customerId, instanceId, inventoryId);
  };
};
export var CLEAR_CUSTOMER_INVENTORY = 'CLEAR_CUSTOMER_INVENTORY';
export var clearCustomerInventory = function clearCustomerInventory() {
  return {
    type: CLEAR_CUSTOMER_INVENTORY
  };
};
export var updateFriendlyNamePromise = function updateFriendlyNamePromise(dispatch, customerId, inventoryId, friendlyName) {
  return ThunkHelper(dispatch, UPDATE_INVENTORY_FRIENDLY_NAME_CONSTANTS, {
    method: 'post',
    url: 'SubscriberManagement/UpdateSubscriberInventoryFriendlyName',
    data: {
      FriendlyName: friendlyName,
      InventoryId: inventoryId
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var updateFriendlyName = function updateFriendlyName(customerId, inventory, friendlyName) {
  return function (dispatch) {
    return updateFriendlyNamePromise(dispatch, customerId, inventory.Id, friendlyName);
  };
};
export var SET_INVENTORY_FILTER_DATA = 'SET_INVENTORY_FILTER_DATA';
export var setInventoryFilterData = function setInventoryFilterData(searchBy, searchTerm, filterBy) {
  return {
    type: SET_INVENTORY_FILTER_DATA,
    payload: {
      searchBy: searchBy,
      searchTerm: searchTerm,
      filterBy: filterBy
    }
  };
};
export var SET_INVENTORY_PAGINATION_DATA = 'SET_INVENTORY_PAGINATION_DATA';
export var setInventoryPaginationData = function setInventoryPaginationData(pageNumber, pageSize) {
  return {
    type: SET_INVENTORY_PAGINATION_DATA,
    payload: {
      pageNumber: pageNumber,
      pageSize: pageSize
    }
  };
};
export var SET_PHYSICAL_INVENTORY_NAME = 'SET_PHYSICAL_INVENTORY_NAME';
export var setPhysicalInventoryName = function setPhysicalInventoryName(name) {
  return {
    type: SET_PHYSICAL_INVENTORY_NAME,
    payload: name
  };
};